
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanelPage.css"; // Assuming you have a CSS file for styling

const AdminLoginPage = () => {
  const [adminId, setAdminId] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  // Debug logging
  console.log("AdminLoginPage component rendered");
  console.log("Current URL:", window.location.pathname);

  const handleLogin = (e) => {
    e.preventDefault();
    if (adminId === "admin" && password === "1234") {
      localStorage.setItem("adminAuth", "true");
      navigate("/admin-panel");
    } else {
      alert("Invalid credentials");

    }
  };

  return (

    <div className="login-container">
      <h2>Admin Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Admin ID"
          value={adminId}
          onChange={(e) => setAdminId(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Login</button>
      </form>

    </div>
  );
};

export default AdminLoginPage;
